import styled from 'styled-components';

export default styled.video`
    width: 100%;
    height: 480px;
    margin: 0 auto;
    margin-bottom: 2rem;
    max-width: 854px;
`;
